export default [
  {
    path: "/planes",
    component: () => import("@/views/planes/Listar.vue"),
  },
  {
    path: "/planes/crear",
    component: () => import("@/views/planes/Crear.vue"),
  },
  {
    path: "/planes/editar/:id",
    component: () => import("@/views/planes/Editar.vue"),
  },
];
